module.exports = __webpack_public_path__ + "static/media/MonumentExtended-Regular.5068cc12.ttf";